export * from './banner-list/banner-list.component';
export * from './banner-detail/banner-detail.component';

import { registerRouteComponent } from '@vendure/admin-ui/core';

import { GetBannerDocument } from '../../gql/graphql';
import { BannerListComponent } from './banner-list/banner-list.component';
import { BannerDetailComponent } from './banner-detail/banner-detail.component';

export const BannerRoutes = [
  registerRouteComponent({
    path: 'banners',
    component: BannerListComponent,
    breadcrumb: [
      {
        label: 'Banners',
        link: ['/extensions', 'grupo-loja', 'banners'],
      },
    ],
  }),
  registerRouteComponent({
    path: 'banners/:id',
    // routeConfig: {
    //   canDeactivate: [CanDeactivateDetailGuard],
    // }, Await for fix https://github.com/vendure-ecommerce/vendure/issues/2535
    component: BannerDetailComponent,
    query: GetBannerDocument,
    entityKey: 'banner',
    getBreadcrumbs: entity => [
      {
        label: 'Banners',
        link: ['/extensions', 'grupo-loja', 'banners'],
      },
      {
        label: entity ? `#${entity?.slug}` : 'Novo Banner',
        link: [],
      },
    ],
  }),
];
